export const getHistoryFrag = `
    id
    version
    dateTo
    expertiseCode
    limitationOfPaymentByLocation
    explanation
    durationOfProcedureBearer
    paymentCategory
    points
    description
    duration
`;

export const serviceMedicalProcedureGridItemFrag = `
    id
    code
    active
    customCode
    customName
    color
    frequency
    executionTolerance
    textTemplate
    courseDescription
    dateFrom
    dateTo
    version
    procedure {
        code
        expertiseCode
        limitationOfPaymentByLocation
        limitationOfPaymentByFrequency
        limitationOfPerformingToExpertise
        explanation
        flag
        paymentCategory
        possibleBillingOfSpecialMaterialOrMedication
        description
        duration
        durationOfProcedureBearer
        price
        pointsDirect
        pointsPersonal
        pointsOverhead
        points
        lastRevision
        procedureBeginsWith
        procedureContentAndScope
        procedureEndsWith
    }
`;
